import { render, staticRenderFns } from "./OnboardingAccommodationDescriptionPage.vue?vue&type=template&id=0333a2f5&scoped=true&"
import script from "./OnboardingAccommodationDescriptionPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingAccommodationDescriptionPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingAccommodationDescriptionPage.vue?vue&type=style&index=0&id=0333a2f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0333a2f5",
  null
  
)

export default component.exports